import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router/index'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        search: '',
        searchTerm: '',
        // darkmode: false,
        appFrame: false,
        navBar: false,
        user: {},
        userIsValid: true,
        visibleSearch: true,
        selectedApp: '',
        userDoc: null,
        groupId: '',
        group : null
    },
    getters: {
        userIsValid: state => state.userIsValid,
        userType: state => state.user.type
    },
    mutations: {
        setUser(state, target) {
            state.user = target;

            if(state.user.type == 'sudo' && state.user.businesses)
                state.user.businesses = []
        },
        setBusinessesList(state, target) {
            state.businessesList = target
        },
        setUserValidity(state, target) {
            state.userIsValid = target;
            setTimeout(() => {
                state.userIsValid = true;
            }, 3000);
        },
        setSearch(state, target) {
            state.search = target;
        },
        setSearchTerm(state, target) {
            state.searchTerm = target;
        },
        setDarkMode(state, target) {
            state.darkmode = target;
        },
        setAppFrame(state, target) {
            state.appFrame = target;
        },
        setNavBar(state, target) {
            state.navBar = target;
        },
        setEnvironment(state, target) {
            state.environment = target;
        },
        setSelectedApp(state, target) {
           state.selectedApp = target;
           router.push({ path : `/images` })
        }
    },
    actions: {
        addApp: ({commit, state}, App) => {
            commit('setSelectedApp', App)
        }
    },
    modules: {},
    // plugins: [vuexPersist.plugin]
})
